var render = function render(){var _vm=this,_c=_vm._self._c;return _c('apexchart',{attrs:{"height":62,"options":_vm.visitorBarChartConfig,"series":[{ name: 'Subscribers',data: _vm.CrmSalesAreaChartsSeries }]}})
}
var staticRenderFns = []

export { render, staticRenderFns }